import * as THREE from "../../../src/insole-web-common/vendor/three/build/three.module.js";
export const mainAxisDirs = [
    new THREE.Vector3(1, 0, 0),
    new THREE.Vector3(0, 1, 0),
    new THREE.Vector3(0, 0, 1),
    new THREE.Vector3(-1, 0, 0),
    new THREE.Vector3(0, -1, 0),
    new THREE.Vector3(0, 0, -1),
];
export function UpdateGeometryFromMeshData(geometry, meshData) {
    function UpdateAttribute(name, newData, normalized) {
        let attribute = geometry.getAttribute(name);
        if (!attribute || attribute.count < newData.length / 3) {
            attribute = new THREE.BufferAttribute(newData, 3, normalized);
            geometry.setAttribute(name, attribute);
        }
        else {
            const array = attribute.array;
            array.set(newData);
            attribute.needsUpdate = true;
        }
    }
    UpdateAttribute("position", meshData.vertices, false);
    if (meshData.normals) {
        UpdateAttribute("normal", meshData.normals, true);
    }
    const index = geometry.getIndex();
    if (!index || index.count < meshData.triangles.length) {
        geometry.setIndex(new THREE.BufferAttribute(meshData.triangles, 1, false));
        geometry.setDrawRange(0, Infinity);
    }
    else {
        const array = index.array;
        array.set(meshData.triangles);
        index.needsUpdate = true;
        geometry.setDrawRange(0, meshData.triangles.length);
    }
}
export function CalculateMeshBounds(vertices) {
    const inf = 1000000.0;
    const ret = {
        minX: inf,
        minY: inf,
        minZ: inf,
        maxX: -inf,
        maxY: -inf,
        maxZ: -inf,
    };
    for (let i = 0; i < vertices.length; ++i) {
        const v = vertices[i];
        const coordIndex = i % 3;
        switch (coordIndex) {
            case 0:
                if (v < ret.minX) {
                    ret.minX = v;
                }
                if (v > ret.maxX) {
                    ret.maxX = v;
                }
                break;
            case 1:
                if (v < ret.minY) {
                    ret.minY = v;
                }
                if (v > ret.maxY) {
                    ret.maxY = v;
                }
                break;
            case 2:
                if (v < ret.minZ) {
                    ret.minZ = v;
                }
                if (v > ret.maxZ) {
                    ret.maxZ = v;
                }
                break;
        }
    }
    return ret;
}
//# sourceMappingURL=mesh-utils.js.map